export const UserAuthActionType = {
  GET_AUTH_TOKEN: 'GET_AUTH_TOKEN',
  GET_AUTH_TOKEN_REJECTED: 'GET_AUTH_TOKEN_REJECTED',
  GET_AUTH_TOKEN_FULFILLED: 'GET_AUTH_TOKEN_FULFILLED',

  REMOVE_AUTH_TOKEN: 'REMOVE_AUTH_TOKEN',
};
